/**
 *  Note this file automatically generated from
 *  @link http://gitlab.fimacomarketing.com:10080/ProninE/BGServerGame/tree/master/ServerPHP/daemon/daemon_node/public/minigames/twentyone/MinigameMath21.js
 */
'use strict';
import { MinigameMathCommon } from '../common/MinigameMathCommon'

/**
 * MinigameCoinMath class.
 *
 * About classes  https://learn.javascript.ru/class-inheritance
 * @inheritDoc
 */

export function MinigameMath21(socket) {
    const MINIGAME_21 = 2;

    MinigameMathCommon.call(this,socket, MINIGAME_21);


    this.m_model = {
        // fixme
        // Здесь стоит описать приблизительно ту модель что приходит от сервера
        // чтобы твоя IDE тебе подсказывала
        "is_fake": true, // fake marker
        "settings": {
            "background":1,
            "bet_type": null
        },
        "bet": {
            "value": 50,
            "currency": {
                "code_name" : "Cr"
            }
        },
        "history" : [ ]
    };
}

MinigameMath21.prototype = Object.create(MinigameMathCommon.prototype);
MinigameMath21.prototype.constructor = MinigameMath21;

MinigameMath21.prototype.__validateModel = function(model) {

    // Здесь мы валидируем модель
    // следим чтобы ставка была в валюте игрока если можно менять ставку
    // если игра запущена - валюту ставки не меняем

    // fixme
    // if(model.bet.currency.code_name != this.m_player_info.account.currency.code_name)
    //     model.bet.currency = this.m_player_info.account.currency;

    return model;
};

/***
 *
 * Список методов смотри в https://docs.google.com/document/d/1PA7rX9Sc2CraxYrxhcct6Fuqs64WrLI6L1Gbv-1Xoz4/edit#heading=h.qle1mk2itim8
 *
 * у Андеря уточни параметры и какой метод когда дергать
 *
 *  по идеи должно быть так:
 *
 *  пока игрок выбирает ставку ты дерагешь  setBetValue (что меняет ставку только локально)
 *
 *  потом игрок дергает "играть" -> doStart с указанием размера ставки и валюты (model.bet)
 *     выдается 2 карты диллеру и нам
 *
 *  еще карта doMore - выдается еще одна карта
 *
 *  как игрок решил что хватит doStop
 *     выдаются карты диллеру
 *
 *  как ты показал карты диллера  и поздравил игрока вызвываешь doTake чтобы забрать выиграшь в кредиты
 *     если проиграл то тоже самое
 *
 *
 *
 *
 */

// reset account( for development )
MinigameMath21.prototype.reinit = function(cb) {
    var params = {};
    this.m_minigame_connector.doAction("reinit", params , cb);
};


/**
 * Start game
 * @param {bet|null}      bet
 * @param {function(e,r)} cb
 */
MinigameMath21.prototype.doStart = function( bet, cb) {
    var params = {
        "bet" :  bet
        //  уточни у Андрея параметры
    };
    this.m_minigame_connector.doAction("doStart", params , cb);
};


/**
 * получить еще карту
 * @param {function(e,r)} cb
 */
MinigameMath21.prototype.doMore = function( cb) {
    var params = {"modelHash": this.m_model.local.model_hash};
    this.m_minigame_connector.doAction("doMore", params , cb);
};


/**
 * завершить с текущем количеством очков
 * @param {function(e,r)} cb
 */
MinigameMath21.prototype.doStop = function(cb) {
    var params = {};
    this.m_minigame_connector.doAction("doStop", params , cb);
};

/**
 * забрать выигрыш если есть.
 * @param cb
 */
MinigameMath21.prototype.doTake = function(cb) {
    this.m_minigame_connector.doAction("doTake", {}, cb);
};

MinigameMath21.prototype.setBetValue = function(bet_value) {
    if(bet_value > this.m_player_info.account.value)
        return false;
    if(!this.m_model.bet)
        this.m_model.bet = {};

    this.m_model.bet.value = bet_value;
    this.m_model.bet.currency = this.m_player_info.account.currency;
    this.m_model.bet.origin_account = {
        uuid: this.m_player_info.account.uuid
    };
    return true;
};


/**
 * установить ставку
 * @param {bet} bet
 * @param {function(e,r)} cb
 */
MinigameMath21.prototype.doBetSet = function(bet, cb) {
    this.m_minigame_connector.doAction("betSet", {"bet":bet} , cb);
};

/**
 * set settings
 * @param {object} settings
 * @param {function(e,r)} cb
 */
MinigameMath21.prototype.doSetSettings = function(settings, cb) {
    this.m_minigame_connector.doAction("settingsSet", {"settings":settings} , cb);
};

MinigameMath21.prototype.localStateChange = function() {
    this.__onGameModelChanged(this.m_model, true, this.m_model.local.model_hash);
};


//////////////////
// WEBPACK FOOTER
// ./src/library/minigame_client/twentyone/MinigameMath21.js
// module id = 125
// module chunks = 0